import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaSaldosSaldo', NominasNominaSaldosSaldo)

function NominasNominaSaldosSaldo($http) {
  this.get = _get
  this.post = _post

  function _get(idNomina, idProyecto, idColaborador, idMoneda) {
    return $http.get('api/nominas/nomina/saldos/saldo', {
      params: {
        id_nomina: idNomina,
        id_proyecto: idProyecto,
        id_colaborador: idColaborador,
        id_moneda: idMoneda,
      },
      schema: NominasNominaSaldosSaldoSchema,
    })
  }

  function _post(idNomina, idProyecto, idColaborador, data) {
    return $http.post('api/nominas/nomina/saldos/saldo', data, {
      params: {
        id_nomina: idNomina,
        id_proyecto: idProyecto,
        id_colaborador: idColaborador,
      },
      schema: NominasNominaSaldosSaldoSchema,
      clearCache: 'nominas',
    })
  }
}

let NominasNominaSaldosSaldoSchema = {
  nominas: {
    fecha: 'date',
    id_moneda: 'number',
    importe: 'number',
    tipo_cambio: 'number',
  },
  saldos: {
    id_concepto: 'number',
    id_moneda: 'number',
    importe: 'number',
    tipo_cambio: 'number',
  },
  movimientos: {
    cargo: {
      id_concepto: 'number',
      id_moneda: 'number',
      fecha: 'date',
      importe: 'number',
    },
    abono: {
      id_concepto: 'number',
      id_moneda: 'number',
      fecha: 'date',
      importe: 'number',
    },
  },
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Saldos/Saldo.js